<template>
  <div class="idle-overlay">
    <div class="idle-modal">
      <div class="p-3">
        <h4 class="idle-modal__title">Session Expired</h4>
        <p>You have left this browser idle for 60 minutes.</p>
        <p v-if="isLoggedIn">{{ time / 1000 }} second left</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 30000,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["app/isLoggedIn"];
    },
  },
  created() {
    let timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
        // Your logout function should be over here
        // alert("logout user....");

        // Log the user out (Invalidate the token).
        this.$store.dispatch("app/logoutUserFromBackend");

        setTimeout(function () {
          localStorage.removeItem("accessToken");

          // Remove userData from localStorage
          localStorage.removeItem("userData");

          localStorage.removeItem("settingSystem");
        }, 2000);

        // Reset ability
        // this.$ability.update(initialAbility)

        // Redirect to login page
        this.$router.push({
          name: "login",
        });
      }
    }, 1000);
  },
};
</script>

<style>
.idle-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.idle-modal {
  width: 500px;
  box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
  border-radius: 4px;
  @apply bg-white p-2;
  background: #fff;
}

.idle-modal__title {
  color: #38404f;
  @apply flex items-center justify-between p-3 font-bold;
}
</style>